<template>
  <v-container fluid>
    <h2 class="mb-5 mt-2">
      Paieška
    </h2>
    <template v-if="!galimaPaieska">
      <v-card class="pa-5">
        <el-role-negalima
          class="mt-2"
          text="Jūs neturite įgaliojimų atlikti šį veiksmą"
        />
      </v-card>
    </template>
    <template v-if="galimaPaieska">
      <v-sheet class="d-flex justify-start" color="transparent">
        <v-card flat style="width: 200px;" color="transparent" class="mr-5">
          <v-card>
            <v-list dense>
              <v-list-item-group v-model="activeTab" color="primary" mandatory>
                <v-list-item
                  v-for="(item, i) in filteredTabItems"
                  :key="i"
                  @click="gotoTab(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      :class="tabClass(item)"
                      v-text="item.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-card>
        <v-card v-if="activeTab >= 0" width="100%" min-width="400px">
          <component
            :is="routeItems[activeRoute].component"
            :key="routeItems[activeRoute].tipas"
            :tipas="routeItems[activeRoute].tipas"
            :form-title="routeItems[activeRoute].formTitle"
            class="tabComponent"
          ></component>
        </v-card>
      </v-sheet>
    </template>
  </v-container>
</template>

<script>
import { authRoute } from './../../router/routeRole'
import PaieskaForm from './PaieskaForm'
import PaieskaMano from './PaieskaMano'
import userRole from '../../mixins/userRole'

export default {
  name: 'SavPaieskaTab',
  mixins: [userRole],
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Pagal juridinį asmenį',
          formTitle: 'Paieška pagal juridinį asmenį',
          route: 'savPaieskaJuridinis',
          tipas: 'juridinis',
          component: PaieskaForm,
          readonly: false,
        },
        {
          title: 'Pagal fizinį asmenį',
          formTitle: 'Paieška pagal fizinį asmenį',
          route: 'savPaieskaFizinis',
          tipas: 'fizinis',
          component: PaieskaForm,
          readonly: false,
        },
        {
          title: 'Pagal turtą',
          formTitle: 'Paieška pagal turtą',
          route: 'savPaieskaTurtas',
          tipas: 'turtas',
          component: PaieskaForm,
          readonly: false,
        },
        {
          title: 'Pagal identifikavimo kodą',
          formTitle: 'Paieška pagal identifikavimo kodą',
          route: 'savPaieskaKodas',
          tipas: 'kodas',
          component: PaieskaForm,
          readonly: false,
        },
        {
          title: 'Mano paieškos',
          formTitle: 'Mano paieškos',
          route: 'savPaieskaMano',
          tipas: 'mano',
          component: PaieskaMano,
          readonly: false,
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter(item => {
        return !item.hide && authRoute(item.route)
      })
    },
    filteredTabItems() {
      return this.tabItems.filter(item => {
        return !item.hide
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function(item, index) {
          return this.$route.matched.find(element => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function(item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
    galimaPaieska() {
      return !this.role('EL_igaliotinis') || this.role('EL_igaliojimas_paieska')
    },
  },
  created() {
    this.selectedTab = this.activeTab
    this.$store.dispatch('loadPaieskaInfo')
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
    tabClass(item) {
      return 'tabItem ' + (item.readonly ? 'readonly' : '')
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.tabItem {
  &.readonly {
    color: $secondary;
  }
}
.tabComponent {
  margin: 0 auto 0 0;
}
.div-inline {
  display: inline-flex;
}
.div-tooltip {
  font-size: 14px;
}
</style>
